import { Component } from '@angular/core';
import {AlertController, NavController, NavParams} from 'ionic-angular';
import {GlobalProvider} from "../../providers/global/global";
import {HttpClient, HttpParams} from "@angular/common/http";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import * as moment from "moment";
import {SettingService} from "../../store/setting/setting.service";
import {SettingEntity} from "../../store/setting/setting.entity";
import {Subscription} from "rxjs/Subscription";

/**
 * Generated class for the SettingCertificatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-setting-certificate',
  templateUrl: 'setting-certificate.html',
})
export class SettingCertificatePage {

  private settingDocument: any;
  public editMode: boolean = false;
  public license_valid: boolean = false;

  private _settingSubscription: Subscription;

  public license: {
    expired_at: number,
    mail: string,
    key: string,
    team_sharing: boolean,
    customer_portal: boolean
  } = {expired_at: null, mail: '-', key: '-', team_sharing: false, customer_portal: false};

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              private globalProvider: GlobalProvider,
              private http: HttpClient,
              private alertCtrl: AlertController,
              private settingService: SettingService) {

  }

  ionViewDidLoad() {
    this._settingSubscription = this.settingService.get()
      .subscribe((settingDocument: SettingEntity) => {
        this.settingDocument = settingDocument
        this.license = settingDocument.license;

        if(this.license.expired_at !== null && moment(this.license.expired_at).isSameOrAfter(moment())){
          this.license_valid = true;
        }
      })
  }

  ionViewWillLeave(){
    this._settingSubscription.unsubscribe();
  }

  public checkLicence(): void {
    //todo: lizenz überprüfen und ergebnis in settings.licence speichern
    let params = {
      'wc-api':         'license-api',
      'request':        'activation',
      'license_email':  this.license.mail,
      'license_key':    this.license.key,
      'user_uuid':      this.globalProvider.user.uuid,
      'database_uuid':  this.globalProvider.database.uuid
    };

    this.http.get('https://cleverreport.de/', {params: params})
      .finally(() => {
        this.editMode = false;
      })
      .subscribe((response) => {

        if(this.globalProvider.validateLicenseApiResponse(response)){
          if(response.hasOwnProperty('error')){
            console.log(response['error']);
            this.alertCtrl.create({
              title: 'Fehler bei der Aktivierung',
              subTitle: response['error'],
              buttons: ['Ok']
            }).present();
          }
          else{
              this.license.expired_at       = response['expired_at'];
              this.license.team_sharing     = response['team_sharing'];
              this.license.customer_portal  = response['customer_portal'];
              this.license_valid            = true;
              this.settingDocument.license  = this.license;
          }
          this.settingService.set(this.settingDocument, false);
        }
        else {
          console.log('response not valid');
        }
      })
  }

  public openCertificatePageInBrowser(): void {
    //todo: Lizenzseite im Browser öffnen
    window.open(this.globalProvider.shopURL, '_blank');
  }

  public deactivateLicense(): void {
    //todo: Lizenz deaktivieren, bzw. für neue aktivierung freigeben

    let params = {
      'wc-api':       'license-api',
      'request':      'deactivation',
      'license_email':this.license.mail,
      'license_key':  this.license.key,
      'user_uuid':    this.globalProvider.user.uuid
    };

    this.http.get('https://cleverreport.de/', {params: params})
      .finally(() => {
        this.editMode = false;
      })
      .subscribe((response) => {
        if(this.globalProvider.validateLicenseApiResponse(response)){

          if(!response.hasOwnProperty('error')){
            this.license.mail       = null;
            this.license.key        = null;
            this.license.expired_at  = null;

            this.license_valid = false;

            this.settingDocument.license = this.license;
            this.settingService.set(this.settingDocument, false);
          }
          else{
            //show error message to user;
            this.alertCtrl.create({
              title: 'Fehler bei der Deaktivierung',
              subTitle: response['error'],
              buttons: ['Ok']
            }).present();
          }
        }
        else {
          console.log('response not valid');
        }
      })
  }

}



// WEBPACK FOOTER //
// ./src/pages/setting-certificate/setting-certificate.ts